import { ColDef } from '@ag-grid-community/core';

import {
    COL_DEF_CLIENTCOD,
    COL_DEF_COMMENT,
    COL_DEF_COUNTER_AMOUNT,
    COL_DEF_COUNTER_CCY,
    COL_DEF_CPTY,
    COL_DEF_DEAL_NUMBER,
    COL_DEF_DEAL_TYPE,
    COL_DEF_DEALT_AMOUNT,
    COL_DEF_DEALT_CCY,
    COL_DEF_ENTERED_BY,
    COL_DEF_EXEC_DATE,
    COL_DEF_FILLED_AT,
    COL_DEF_FILLED_BY,
    COL_DEF_FINAL_RATE,
    COL_DEF_FX_POINTS,
    COL_DEF_LAST_MOD,
    COL_DEF_LAST_MOD_BY,
    COL_DEF_LAST_MOD_TIME,
    COL_DEF_LEG_TYPE,
    COL_DEF_MATURITY_DATE,
    COL_DEF_PAIR,
    COL_DEF_POINTS_MARGIN,
    COL_DEF_SFX_ORDER_ID,
    COL_DEF_SIDE,
    COL_DEF_SPOT_MARGIN,
    COL_DEF_SPOT_RATE,
    COL_DEF_STATUS,
    COL_DEF_TRADE_DATE,
} from './kondor-blotter.service.data';

export function getKondorBlotterColumnDefs(columnNames: Array<string>): Array<ColDef> {
    return [
        COL_DEF_LAST_MOD,
        COL_DEF_DEAL_NUMBER,
        COL_DEF_ENTERED_BY,
        COL_DEF_CPTY,
        COL_DEF_SIDE,
        COL_DEF_DEAL_TYPE,
        COL_DEF_MATURITY_DATE,
        COL_DEF_PAIR,
        COL_DEF_DEALT_CCY,
        COL_DEF_DEALT_AMOUNT,
        COL_DEF_COUNTER_CCY,
        COL_DEF_COUNTER_AMOUNT,
        COL_DEF_SPOT_RATE,
        COL_DEF_FX_POINTS,
        COL_DEF_FINAL_RATE,
        COL_DEF_TRADE_DATE,
        COL_DEF_FILLED_BY,
        COL_DEF_FILLED_AT,
        COL_DEF_SFX_ORDER_ID,
        COL_DEF_EXEC_DATE,
        COL_DEF_LEG_TYPE,
        COL_DEF_SPOT_MARGIN,
        COL_DEF_POINTS_MARGIN,
        COL_DEF_COMMENT,
        COL_DEF_STATUS,
        COL_DEF_LAST_MOD_TIME,
        COL_DEF_LAST_MOD_BY,
        COL_DEF_CLIENTCOD,
    ].filter(colDef => columnNames.includes(colDef.field));
}

export type IOrderStatus = 'INS' | 'UPD' | 'DEL';

export const orderStatusMapper: Record<IOrderStatus, string> = {
    INS: 'Inserted',
    UPD: 'Updated',
    DEL: 'Deleted',
};
